import React, { useContext } from "react";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  MutedLink,
  SubmitButton,
} from "./common";
import { Marginer } from "../marginer/marginer";
import { AccountContext } from "./accountContext";

export function LoginForm(props) {
  const { switchToSignup } = useContext(AccountContext);

  return (
    <BoxContainer>
      <FormContainer>
        <Input type="email" placeholder="ایمیل" />
        <Input type="password" placeholder="کلمه عبور" />
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      <Marginer direction="vertical" margin="1.6em" />
      <SubmitButton type="submit">ورود</SubmitButton>
      <Marginer direction="vertical" margin="1em" />
      <MutedLink href="#">
        حساب کاربری ندارید ؟{" "}
        <BoldLink href="#" onClick={switchToSignup}>
          ساخت حساب
        </BoldLink>
      </MutedLink>
    </BoxContainer>
  );
}
